/**
 * Created by lhzbxx on 2016/11/5.
 *
 * global.js
 * 管理全局的状态
 */

import * as types from '../mutation-types'
import data from '../../api/data'

const state = {
  region:null,
  needLogin: 0,
  history: [],
  currentCompany: {}
}

const mutations = {
  [types.CHANGE_REGION] (state, code) {
    state.region = data.regions.find(r => r.code === code)
  },
  [types.REQUIRE_LOGIN] (state) {
    state.needLogin += 1
  },
  [types.BROWSE_PRODUCT] (state, product) {
    state.history.push(product)
    // 最多保持6条记录。
    if (state.history.length > 6) {
      state.history.pop()
    }
    window.localStorage.setItem('history', JSON.stringify(state.history))
  },
  [types.GET_DATA_FROM_STORAGE] (state) {
    console.log('global:GET_DATA_FROM_STORAGE')
    state.history = JSON.parse(window.localStorage.getItem('history')) || []
  }
}

export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/module/global.js